<ng-container *ngIf="!isLoading">
  <h3 mat-dialog-title>Preprogram Pricesheet</h3>
  <form fxLayout="column" [formGroup]="preprogramForm">
    <mat-form-field>
      <mat-label>Preprogram Amount ($)</mat-label>
      <input inputCurrencyNumber matInput formControlName="Amount" required rows="5" />
    </mat-form-field>
  </form>
  <mat-dialog-actions fxLayout="row" fxLayoutGap="5pt" fxLayoutAlign="end center">
    <button mat-button type="button" color="warn" [mat-dialog-close]="false">
      <mat-icon class="material-icons-outlined">cancel</mat-icon>
      Exit
    </button>
    <button [disabled]="!preprogramForm.valid" mat-button type="submit" color="accent" (click)="createPreprogramPricesheet()">
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      Submit
    </button>
  </mat-dialog-actions>
</ng-container>
<div *ngIf="isLoading">
  <h3 mat-dialog-title>Loading...</h3>
  <div fxLayout="row" fxLayoutAlign="center center">
    <app-loading [isRelative]="true"></app-loading>
  </div>
</div>

